// extracted by mini-css-extract-plugin
export default {"clickaway":"modal_clickaway__ClqZV","modal":"modal_modal__2S6Ci","title":"modal_title__0wqAu"};